import React,{Component} from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { Redirect } from "react-router-dom";
import ReadAloud from "components/Question/Speaking/ReadAloud.jsx";
import DescribeImage from "components/Question/Speaking/DescribeImage.jsx";
import RepeatSentece from "components/Question/Speaking/RepeatSentece.jsx";
import RetellLec from "components/Question/Speaking/RetellLec.jsx";
import ShortQue from "components/Question/Speaking/ShortQue.jsx";
import Summary from "components/Question/Writting/Summary.jsx";
import Essay from "components/Question/Writting/Essay.jsx";
import ChromeCheck from "views/ChromeCheckGlobal.jsx";
import SingleAnswer from "components/Question/Reading/SingleAnswer.jsx";
import MultipleAnswer from "components/Question/Reading/MultipleAnswer.jsx";
import Reorder from "components/Question/Reading/Reorder.jsx";
import ReadingBlank from "components/Question/Reading/ReadingBlank.jsx";
import WrittingBlank from "components/Question/Reading/WrittingBlank.jsx";
import Summer from "components/Question/Listening/Summer.jsx";
import McqSingle from "components/Question/Listening/McqSingle.jsx";
import McqMulti from "components/Question/Listening/McqMulti.jsx";
import ListeningBlank from "components/Question/Listening/ListeningBlank.jsx";
import MissingWord from "components/Question/Listening/MissingWord.jsx";
import CorrectSummary from "components/Question/Listening/CorrectSummary.jsx";
import Dictation from "components/Question/Listening/Dictation.jsx";
import Highlight from "components/Question/Listening/Highlight.jsx";
import ResourceCheck from "./ResourceCheck.jsx";
// core components
import style from "components/test.css";
import { NavLink } from "react-router-dom";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import API from "api.js";
import {store} from 'store/index';
import { setAlert} from 'action/index.js';
class Test extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionData:[],
      currentQuestion:0,
      isRecording: false,
      blobURL: '',
      isBlocked: false,
      type:'',
      result:{},
      finalResult:[],
      lastFlag:true,
      resultId:false,
      secondCount:0,
      submitProcess:false,
      saveProcess:false,
      dashboardFlag:false,
      resourceTested:false,
      mockCat:false,
      mockTime:20,
      title:'',
      modal:false,
      pending:0,
      msg:'',
      nextType:0,
      qTime:0,
      stopRecording:false,
      soundStat:true,
      soundModal: false,
      soundArr:[2,4,5,13,14,15,16,17,18,19,20],
      q_count:0,
      timeOutFlag:false,
      all_ok:false,
      ids:[],
      complete:0
    };
  }
/*2,4,5,13,14,15,16,17,18,19,20*/
  componentDidMount() {
    let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)  && !/Chromium/.test(navigator.userAgent);
      let all_ok = (isChrome)?true:false;
      navigator.getUserMedia({ audio: true },
      () => {                   
        console.log('Permission Granted');
        this.setState({all_ok:all_ok}); 
      },
      () => {
        console.log('Permission Denied');
        
      },
    );
    document.body.classList.toggle("sidebar-mini");
    document.body.classList.toggle("sidebar-test-close");
    //document.querySelector('#minimizeSidebar').style.display = "none"
    API({
        method: 'GET',
        url: 'question/detail/'+this.props.match.params.id+'/'+this.props.match.params.pending
      }).then(data => {
        console.log(data.data);
        this.setState({ids:data.data.mock.question,title:data.data.mock.title,mockCat:data.data.mock.category,'questionData':data.data.mock.question,type:data.data.mock.question[0].subcategory_id});
        var intervalId = setInterval(this.timer, 1000);
        let soundStat = true;
        if (this.state.soundArr.includes(data.data.mock.question[0].subcategory_id)) {
          soundStat=false;
        }
        this.setState({q_count:data.data.q_count,soundStat:soundStat,intervalId: intervalId,secondCount:parseFloat(data.data.time)*60,mockTime:parseFloat(data.data.time)*60});
        
    }).catch(()=>{
      
    });
      navigator.getUserMedia({ audio: true },
        () => {
          console.log('Permission Granted');
          this.setState({ isBlocked: false });
        },
        () => {
          console.log('Permission Denied');
          this.setState({ isBlocked: true })
        },
      );

  }

  submitResponse = (data,f=false) => {
    
    let obj = {
      data:data.data,
      text_answer:data.answer,
      length:data.length,
      correct:data.correct
    };
    if (f) {
        
      
    }else{
      this.setState({result:obj});    
    }
    
  }

  resultStatus = () => {
    this.setState({is_result:true});

  }

  timer = () => {
    if (this.state.secondCount === 1) {
      this.setState({dashboardFlag:true,timeOutFlag:true});
      let bodyFormData = new FormData();
      this.setState({stopRecording: true,pending:1,nextType:1,complete:1});
      bodyFormData.append('mock_id', this.props.match.params.id);
      
      this.state.ids.map((v,k) => {
        if (k!==0) {
          bodyFormData.append('id[]', v.id );  
        }
        
      });
      API({
        method: 'Post',
        url: 'set/mockTime',
        data:bodyFormData
      }).then(data => {
      });
      clearInterval(this.state.intervalId);
    }
    this.setState({ secondCount: this.state.secondCount -1, qTime: this.state.qTime+1 });
  }

  componentWillUnmount = () => {
    document.body.classList.toggle("sidebar-mini");
    document.body.classList.toggle("sidebar-test-close");
    //document.querySelector('#minimizeSidebar').style.display = "block"
    clearInterval(this.state.intervalId);
  }

  nextButton = (e,p) => {
    if (!this.state.soundStat) {
      this.setState({soundModal:true});
    }else{
      let pending = 0;
      let msg ="";
      let complete = 0;
      if (p ===0) {
        pending = 0;
        msg = "Do you want to go to next Question?";
      }else if(p === 1){
        pending = 0;
        msg = "Do you want to submit test?";
        complete = 1;
        clearInterval(this.state.intervalId)
      }else if(p === 2){
        msg = "Do you want to save this question and exit mock test?";
        pending = 1;
        clearInterval(this.state.intervalId)
      }
      this.setState({'modal':true,'pending':pending,msg:msg,nextType:p,complete:complete});  
    }
    

  }

  toggleYes = () => {
    this.setState({
        stopRecording: true
    });
    
  }

   nextQuestion = async (obj) =>{
    let obj2 = {
      data:obj.data,
      text_answer:obj.answer,
      length:obj.length,
      correct:obj.correct,
      second:obj.time,
      lang:obj.lang,
      html: obj.html,
      audio_text:obj.audio_text,
      duration : obj.duration
    };
      let obj1 = await this.finalObjectCreation(obj2);
      this.finalSubmit(obj1);
      if(this.state.nextType === 1 || this.state.nextType === 2){
          this.setState({stopRecording:false,modal:false,dashboardFlag:true}); 
          store.dispatch(setAlert({'flag':true,'type':1,'message':"Mock submitted successfully"}));
      }else{
        let soundStat = true;
        if (this.state.soundArr.includes(this.state.questionData[this.state.currentQuestion+1].subcategory_id)) {
          soundStat=false;
        }
      this.setState({soundStat:soundStat,stopRecording:false,result:{},currentQuestion:this.state.currentQuestion + 1,type:this.state.questionData[this.state.currentQuestion+1].subcategory_id,modal:false},()=>{
        this.forceUpdate();  
      });
    }
    
  }

  finalSubmit = (obj1) =>{
    let curr = this.state.questionData[this.state.currentQuestion]; 
    let obj = [];
    let time = this.state.secondCount;
    obj.push(obj1);
    let finalArr = [];
    /*if(this.state.lastFlag){
      finalArr = [...this.state.finalResult,obj];
      this.setState({finalResult:[...this.state.finalResult,obj],lastFlag:false})
    }else{
      finalArr = this.state.finalResult;
    }*/
      let bodyFormData = new FormData();
      if(this.props.match.params.pending == 1){
        bodyFormData.append('result_id', this.props.match.params.id);  
      }
      bodyFormData.append('q_count', this.state.questionData.length);
      bodyFormData.append('mock_id', this.props.match.params.id);
      bodyFormData.append('q_time', this.state.qTime);
      bodyFormData.append('pending', this.state.pending);
      bodyFormData.append('curr_q', 0);
      bodyFormData.append('complete', this.state.complete);
      obj.map((v,k) => {
        if ([6,7,13].includes(v.type)) {
          time = (this.state.secondCount-v.second);
          if (time < 1) {
            time = 1
          }
          //this.setState({secondCount: (this.state.secondCount-v.second)})
          bodyFormData.append('time', time );
          
        }else{
          time = this.state.secondCount;
          bodyFormData.append('time', this.state.secondCount);
        }
        bodyFormData.append('response[]',v.response);
        if([1,2,3,4,5].includes(v.type)){
          bodyFormData.append('text[]', v.answer);
          bodyFormData.append('lang[]', v.lang);
          bodyFormData.append('selected[]', v.text_answer);
          bodyFormData.append('text_answer[]', v.text_answer);
          bodyFormData.append('answer[]', v.ans);
          bodyFormData.append('q_ans[]', v.q_ans);
          bodyFormData.append('length[]', v.length);
          bodyFormData.append('ans[]', v.q_ans);
          bodyFormData.append('html[]', v.html);
          bodyFormData.append('audio_text[]', v.audio_text);
          if (v.data == "") {
            bodyFormData.append('file[]',  new Blob(['hello worllllllllllllld']));  
          }else if(v.data === undefined){
            bodyFormData.append('file[]',  new Blob(['hello worlppppppppppppd']));
          }else{
            bodyFormData.append('file[]', v.data);
          }
          
          bodyFormData.append('type[]', v.type);
          bodyFormData.append('correct[]', v.correct);
          bodyFormData.append('script[]', v.script);
          bodyFormData.append('id[]', v.id);
          bodyFormData.append('duration[]', v.duration);
        }else if([6,7].includes(v.type)){
            bodyFormData.append('text[]', v.answer);
            bodyFormData.append('text_answer[]', v.text_answer);
            bodyFormData.append('selected[]', v.text_answer);
            bodyFormData.append('type[]', v.type);
            bodyFormData.append('lang[]', v.lang);
            bodyFormData.append('html[]', v.html);
            bodyFormData.append('answer[]', v.q_ans);
            bodyFormData.append('script[]', v.script);
            bodyFormData.append('ans[]', v.q_ans);
            bodyFormData.append('file[]',  new Blob(['hello worlppppppppppppd']));
            bodyFormData.append('correct[]', v.correct);
            bodyFormData.append('length[]', v.length);
            bodyFormData.append('id[]', v.id);
            bodyFormData.append('audio_text[]', v.audio_text);
            bodyFormData.append('q_ans[]', v.q_ans);
            bodyFormData.append('duration[]', v.duration); 
        }
        else if([8,9,10,11,12].includes(v.type)){
          bodyFormData.append('text[]', v.answer);
          bodyFormData.append('selected[]', v.text_answer);
          bodyFormData.append('type[]', v.type);
          bodyFormData.append('lang[]', v.lang);
          bodyFormData.append('text_answer[]', v.text_answer);
          bodyFormData.append('answer[]', v.correct);
          bodyFormData.append('script[]', v.script);
          bodyFormData.append('correct[]', v.correct);
          bodyFormData.append('ans[]', v.q_ans);
          bodyFormData.append('html[]', v.html);
          bodyFormData.append('length[]', v.length);
          bodyFormData.append('id[]', v.id);
          bodyFormData.append('file[]',  new Blob(['hello worlppppppppppppd']));
          bodyFormData.append('q_ans[]', v.q_ans);
          bodyFormData.append('audio_text[]', v.audio_text);
          bodyFormData.append('duration[]', v.duration);
        }
        else if([13,14,15,17,19,20,18,16].includes(v.type)){
            bodyFormData.append('text[]', v.answer);
            bodyFormData.append('selected[]', v.text_answer);
            bodyFormData.append('type[]', v.type);
            bodyFormData.append('answer[]', v.correct);
            bodyFormData.append('script[]', v.script);
            bodyFormData.append('ans[]', v.q_ans);
            bodyFormData.append('lang[]', v.lang);
            bodyFormData.append('correct[]', v.correct);
            bodyFormData.append('length[]', v.length);
            bodyFormData.append('text_answer[]', v.text_answer);
            bodyFormData.append('id[]', v.id);
            bodyFormData.append('html[]', v.html);
            bodyFormData.append('audio_text[]', v.audio_text);
            bodyFormData.append('file[]',  new Blob(['hello worlppppppppppppd']));
            bodyFormData.append('q_ans[]', v.q_ans);
            bodyFormData.append('duration[]', v.duration);
        }
      });
      /*if (flag) {
        this.setState({saveProcess:true});
        bodyFormData.append('pending', 1);
      }else{
        this.setState({submitProcess:true});
        bodyFormData.append('pending', 0);
      }*/
      
      API({
          method: 'POST',
          url: 'submit/mock',
          data:bodyFormData
        }).then(data => {
          let filteredAry = this.state.ids.filter(function(e) { return e.id !== obj[0].id });
          this.setState({secondCount: time,qTime:0,ids:filteredAry});
          console.log(data);
          if (data.status ===200 && data.data.status === 200) {
            /*if (flag) {
              this.setState({submitProcess:false,dashboardFlag:true});  
            }else{
              this.setState({'resultId':data.data.id,submitProcess:false});
            }*/
           // store.dispatch(setAlert({'flag':true,'type':1,'message':data.data.message}));
          }else{
            this.setState({submitProcess:false});
            store.dispatch(setAlert({'flag':true,'type':2,'message':"Something went wrong."}));
          }
      }).catch(()=>{
      
    });
    
  }


  toggle = () =>{
    this.setState({modal:!this.state.modal});
  }

  soundChecked = () =>{
    this.setState({soundStat:true});
  }

  showTest = () => {
    this.setState({resourceTested:true,secondCount:this.state.mockTime});
    this.forceUpdate();
  }

  closeSoundModal = () => {
    this.setState({soundModal:false});
  }

  closeTimeoutModal = () => {
    this.setState({timeOutFlag:false});
  }

  finalObjectCreation = (obj1 = false) => {
    let qdata = this.state.questionData[this.state.currentQuestion];
    let response = true;
    if (Object.keys(this.state.result).length === 0 ) {
     response = true;
    }
    let obj = {};
    if (obj1) {
      obj = {
      ...obj1,
      type:qdata.subcategory_id,
      id:qdata.id,
      response:response,
      answer:qdata.question,
      script:qdata.audio_script,
      q_ans:qdata.answer
    } 
    }else{
      obj = {
      ...this.state.result,
      type:qdata.subcategory_id,
      id:qdata.id,
      response:response,
      answer:qdata.question,
      script:qdata.audio_script,
      q_ans:qdata.answer
    }  
    }
    return obj;
  }

  
  render() {
    let props ={
      submit:this.submitResponse,
      showResult:this.resultStatus,
      data:this.state.questionData[this.state.currentQuestion],
      resultMode:false,
      testMode:true,
      soundChecked:this.soundChecked,
      stopRecording:this.state.stopRecording,
      nextQuestion:this.nextQuestion
    };
    let que;
    let title ="";
    let ques_title ="";
    if (this.state.questionData.length >0) {
      ques_title = this.state.questionData[this.state.currentQuestion].q_title;
    }
    switch(this.state.type) {
      case 1:
        que = <ReadAloud {...props} />;
        title = "Look at the text below. In the 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
        break;
      case 2:
        que = <RepeatSentece {...props} />;
        title = "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
        break;
      case 3:
        que = <DescribeImage {...props} />;
        title = "Look at the Image below. In 25 seconds,please speak into the microphone and describe in detail what the graph showing. You will have 40 seconds to give your response.";
        break;
      case 4:
        que = <RetellLec {...props} />;
        title = "You will hear a lecture. After listening to the lecture, in 10 seconds, please speak into the microphone and retell what you have just heard from the lecture in your own words. You will have 40 seconds to give your response.";
        break;
      case 5:
        que = <ShortQue {...props} />;
        title = "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
        break;
      case 6:
        que = <Summary {...props} />;
        title = "Read the passage and summarize it using one sentence. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. your response will be judge on the quality of your writing and on how well your response presents the key points in the passage.";
        break;
      case 7:
        que = <Essay {...props} />;
        title = "You will have 20 minutes to plan, write and revise an essay about the topic below. your response will be judged on how well you develop a position, oraganize your ideas, present supporting details, and control the elements of standard written English. You should write 200-300 words.";
        break;
      case 8:
        que = <SingleAnswer {...props} />;
        title = "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
        break;
      case 9:
        que = <MultipleAnswer {...props} />;
        title = "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
        break;
      case 10:
        que = <Reorder {...props} />;
        title = "The textbox in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
        break;
      case 11:
        que = <ReadingBlank {...props} />;
        title = "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
        break;
      case 12:
        que = <WrittingBlank {...props} />;
        title = "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
        break;
      case 13:
        que = <Summer {...props} />;
        title = "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should wirte 50-70 words. You have 10 minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.";
        break;
      case 14:
        que = <McqSingle {...props} />;
        title = "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
        break;
      case 15:
        que = <McqMulti {...props} />;
        title = "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
        break;
      case 16:
        que = <ListeningBlank {...props} />;
        title = "You will hear a recording. Type the missing words in each blank.";
        break;
      case 17:
        que = <CorrectSummary {...props} />;
        title = "You will hear a recording. Click on the paragraph that best relates to the recording.";
        break;
      case 18:
        que = <MissingWord {...props} />;
        title = "You will hear a recording about "+ ques_title+". At the end of the recording the last word or group of words has benn replaced by a beep. Select the correct option to complete the recording";
        break;
      case 19:
        que = <Highlight {...props} />;
        title = "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
        break;
      case 20:
        que = <Dictation {...props} />;
        title = "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
        break;
      default:
        // code block
    }

    return (
      <>
      {!this.state.all_ok && <ChromeCheck />}
      {this.state.all_ok && <>
            {this.state.timeOutFlag && <Modal isOpen={this.state.timeOutFlag} size="sm"  >
                            
                            <ModalBody>
                              <div>Test stopped due to timeout.</div>
                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" className="modalCloseBtn" onClick={this.closeTimeoutModal}>OK</Button>
                            </ModalFooter>
                          </Modal>}
            {this.state.soundModal && <Modal isOpen={this.state.soundModal} size="sm"  >
                            
                            <ModalBody>
                              <div>Please wait for question audio to be finished.</div>
                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" className="modalCloseBtn" onClick={this.closeSoundModal}>OK</Button>
                            </ModalFooter>
                          </Modal>}
              {this.state.modal && <Modal isOpen={this.state.modal} size="sm"  >
                            
                            <ModalBody>
                              <div>{this.state.msg}</div>
                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" className="modalCloseBtn" onClick={this.toggleYes}>Yes</Button>
                              <Button color="secondary" className="modalCloseBtn" onClick={this.toggle}>No</Button>
                            </ModalFooter>
                          </Modal>}
            {this.state.mockCat && !this.state.resourceTested && <ResourceCheck showTest={this.showTest} pending={0} data={{}} cat={this.state.mockCat} />}
            
              {this.state.resourceTested && <div className="content questionsArea">
                        <Row>
                          <Col xs={12}>
                            <Card>
                              <CardHeader>
                                <Row>
                                  <Col xs={6}>
                                    <CardTitle tag="h4">
                                      {this.state.title}
                                    </CardTitle>
                                  </Col>
                                  <Col xs={6}>
                                    <div className="text-right questionTime">
                                      <div className="timeRemaining">
                                        <p><i class="fa fa-clock-o"></i> <span>Time Remaining: {Math.floor(this.state.secondCount / 60) +':'+ parseInt(this.state.secondCount % 60)}</span></p>
                                      </div>
                                      <div className="item">
                                        <p>Question {this.state.currentQuestion+this.state.q_count+1} of {this.state.questionData.length+this.state.q_count}</p>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </CardHeader>
                              <CardBody>
                                <h4>{title}</h4>
                                <Row className='unselectable'>
                                {this.state.secondCount === 0 && <div>Time up please restart the Test</div> }     
                                {this.state.secondCount !== 0 &&  this.state.questionData && que }
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xs={12}><div className="bottomBtns">
                            <Row>
                            <Col xs={9}>
                            {!this.state.dashboardFlag && !this.state.saveProcess && !this.state.resultId && this.state.currentQuestion > 0  && this.state.questionData.length !== (this.state.currentQuestion+1) && <Button color="primary" onClick={(e) => this.nextButton(e,2)}  size="xs">Save & Exit</Button>}
                              {this.state.saveProcess &&  !(this.state.questionData.length != (this.state.currentQuestion+1)) && <Button color="primary"  size="xs">Wait...</Button>}
                            {!this.state.dashboardFlag && !this.state.submitProcess && this.state.secondCount !==0 && !this.state.resultId &&  !(this.state.questionData.length != (this.state.currentQuestion+1)) && <Button color="primary" onClick={(e) => this.nextButton(e,1)}  size="xs">Submit</Button>}
                            {this.state.submitProcess &&  !(this.state.questionData.length != (this.state.currentQuestion+1)) && <Button color="primary"  size="xs">Wait...</Button>}
              
                            {this.state.submitProcess &&  !(this.state.questionData.length != (this.state.currentQuestion+1)) && <Button color="primary"  size="xs">Wait...</Button>}
                            {this.state.resultId && <NavLink to={'/admin/result/'+this.state.resultId} > <Button color="primary"  size="xs">Show Result</Button> </NavLink>  }
                            {this.state.dashboardFlag && <NavLink to={'/admin/dashboard'} > <Button color="primary"  size="xs">Go to Dashboard</Button> </NavLink>  }
                            {this.state.timeOutFlag && <div>Test stopped due to timeout</div>}
                            </Col>
                            <Col xs={3}>
                                {!this.state.dashboardFlag && this.state.secondCount !==0 && !this.state.resultId && (this.state.questionData.length != (this.state.currentQuestion+1)) && this.state.questionData.length!==0 && <Button color="primary" onClick={(e) => this.nextButton(e,0)} size="xs">NEXT</Button>}     
                            </Col>
                            </Row>
                            </div>
                          </Col>
                        </Row>
                      </div>}
            </>}
            </>
    );
  }
}

export default Test;
